import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';

// import { deleteResidue } from '../../../../slices/thunks';

// import { setRequireCloseModal } from '../../../../slices/residue/reducer';

import { useSelector, useDispatch } from 'react-redux';
import { finalDestinationReceptionGuide } from '../../../../../slices/thunks';
import { createSelector } from 'reselect';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import EditKilogramsReceivedForm from '../../Forms/EditKilogramsReceivedForm';

const EditKilogramsReceivedModal = ({ dataGuide, isOpen, handlerToggleModal, handlerUpdateGuide}) => {

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader >Editar kilogramos a recepcionar</ModalHeader>
				<ModalBody className=''>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<EditKilogramsReceivedForm
							dataGuide={dataGuide}
							handleToggleModal={handlerToggleModal}
							handlerUpdateGuide={handlerUpdateGuide}
						/>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default EditKilogramsReceivedModal;